import CustomLogoCircle from './logo/gdp-labs-logo-circle.png';
import React from 'react';

const LogoIcon = () => {
  return <img src={CustomLogoCircle} alt="GDP Labs Logo Circle" height={28} />;
};

export default LogoIcon;
